export default {
  responsive: true,
  maintainAspectRatio: false,
  title: {
    display: false
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          drawTicks: false,
          drawBorder: false
        },
        ticks: {
          padding: 8,
          fontSize: 10
        }
      }
    ],
    yAxes: [
      {
        gridLines: {
          drawTicks: false,
          drawBorder: false
        },
        ticks: {
          padding: 5,
          fontSize: 10,
          beginAtZero: true,
          max: 1.2,
          min: 0,
          stepSize: 0.1,
          autoSkip: true,
          callback: (value, index, values) => (value * 10) % 2
            ? ''
            : value
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/constants/acousticPerfChartOptions.js